import { fromFetch } from 'rxjs/fetch';
import { getBreadcrumbContent } from 'constants/routes'

function getBreadcrumbContentRequest$(searchParameters) {
const requestObject = {
        method: 'POST',
        body: JSON.stringify({
          searchCommand: {
            ...searchParameters,
          },
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        selector: (response) => response.json(),
      };
      return fromFetch(getBreadcrumbContent, requestObject);
}

export default getBreadcrumbContentRequest$;
